<template>
    <div class="CategoryULComponent">
        
        <b-form-group id="input-group-Categories" label="Categories:" label-for="input-2">
            <b-form-select v-model="selected" :options="listCategory" size="sm" ></b-form-select>

        </b-form-group>

        
    </div>
</template>

<script>
//import { mapGetters } from 'vuex'
//import vSelect from 'vue-select'

export default {
    name: 'CategoryULComponent',
    components: {
        //vSelect
    },
    props: {
        data: Object,
        lang: Object,
        source: String
    },
    data() {
        return {
            listCategory: [],
            fullList: [],
            id: "treecombo_" + this._uid,
            selected: 1,
            selectedCategoryId: 1
        }
    },
    computed: {
        view() {
            return this.$store.getters.viewForModule;
        }

    },
    created() {


        
        const obj = {
            categoryId: 1,
            category: "All libraries",

        }
        this.$store.commit("SELECTULCATEGORY", obj);

        let vue = this;


        this.$store.dispatch('lm_getFlatCategories')
            .then((result) => {
                console.log(result.data)
                vue.createList(result.data);

                vue.selected = 1;

            })


    },
    updated() {


    },
    watch: {
        
        selected: function (newVal) {
            let categoryName = ""

            if (newVal != undefined) {
                for (let i = 0, lei = this.listCategory.length; i < lei; i++) {
                    
                    if (this.listCategory[i].value == newVal) {
                        categoryName = this.listCategory[i].text;

                        break;
                    }
                }

                const obj = {
                    categoryId: newVal,
                    category: categoryName,

                }
                
                this.$store.commit("SELECTULCATEGORY", obj);
                

            } 

        },

    },
    methods: {
        createList: function (categories) {

            const obj = {
                text: categories.category,
                value: categories.categoryId
            }

            this.listCategory.push(obj);
            this.fullList.push(obj);

            if (categories.children.length > 0) {
                this.categoriesChildren(categories.children);
            }



        },
        categoriesChildren: function (children) {

            for (var i = 0, lei = children.length; i < lei; i++) {

                const obj = {
                    text: children[i].category,
                    value: children[i].categoryId
                }

                
                if (this.source == "hdl symbol" && children[i].libraryType == "hdl_symbols") {
                    this.listCategory.push(obj)
                    
                }
                if (this.source == "symbol" && children[i].libraryType == "orcad_symbols") {
                    this.listCategory.push(obj)
                    
                }
                if (this.source == "footprint" && children[i].libraryType == "orcad_footprints") {
                    this.listCategory.push(obj)
                    
                }


                
                this.fullList.push(obj)


                if (children[i].children.length > 0) {
                    this.categoriesChildren(children[i].children);
                }

            }
        }
    }
}
</script>


<style lang="scss">
.CategoryULComponent {
    
}
</style>



// WEBPACK FOOTER //
// src/components/shared/CategoryULComponent.vue